<template>
    <VForm ref="form" v-if="value">
        <div class="grey lighten-3 px-4 py-4 text-caption rounded-lg mb-6 w-full">
                    <div class="d-flex justify-content-between">
                        <span class="text-subtitle-1">Info</span>
                        <v-btn v-if="!infoAdvanced && !filtersReadonly" @click="infoAdvanced = true" small icon><v-icon small
                                left>mdi-pencil-outline</v-icon></v-btn>
                    </div>
                    <template v-if="infoAdvanced">
                        <v-card outlined class="mt-2">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <eod-object-autocomplete endpoint="measurementTypes" return-object outlined dense clearable
                    :label="'Meetwaarde' + (['thresholds','rateofchange'].includes(value.content.type) ? '*' : '')"
                    :value="value.measurementTypes ? value.measurementTypes[0] : null"
                    :fields="['id', 'name', 'unit{id name fields{name description} list{fields{name}}}', 'valueConfigList{id name description itemType fields{name description isActive}, listItems{id name description low high threshold stepSize color fields{name description isActive}}}', 'valueConfigListItems{id name description low high threshold stepSize color fields{name description isActive}}']"
                    @change="updateMeasurement"
                    :rules="['thresholds','rateofchange'].includes(value.content.type) ? [val => rules.required(val, 'Meetwaarde')] : []"></eod-object-autocomplete>
                                    </v-col>
                                    <v-col v-if="!hideJobtype">
                                        <eod-object-autocomplete class="mb-4" endpoint="jobTypes" return-object outlined dense label="jobType"
                    :value="value.jobTypes ? value.jobTypes[0] : null" @change="val => updateRelation('jobTypes', val)"
                    clearable
                    :fields="['id', 'name', 'defaultProject{id name company{id name}}', 'defaultService{id name}']"></eod-object-autocomplete>
                    <div class="mb-4" v-if="!hideProject">
                        <eod-objects-treeview-input clearable :search="projectSearch" :selectable="['PROJECT']" :classes="['COMPANY', 'PROJECT']" @input="updateProject" :value="(value.projects && value.projects[0])? value.projects[0].id : null" label="Project"></eod-objects-treeview-input>
                    </div>
                    <div class="mb-4" v-if="!hideCompany">
                        <eod-objects-treeview-input clearable :selectable="['COMPANY']" :classes="['COMPANY']" @input="updateCompany" :value="(value.companies && value.companies[0])? value.companies[0].id : null" label="Bedrijf"></eod-objects-treeview-input>
                    </div>
                                    </v-col>
                                    <v-col v-if="!hideProduct">
                                        <div class="mb-4">
                                        <eod-objects-treeview-input clearable :selectable="['DEVICE']" @input="val => updateRelation('products', val?{id:val}:null)" :value="(value.products && value.products[0])? value.products[0].id : null" label="Asset"></eod-objects-treeview-input>
                                    </div>
                                    <!-- <eod-object-autocomplete :key="updateServices" :suggestions="services" class="mb-4" endpoint="services" return-object outlined dense clearable label="Dienst"
                    :value="value.services ? value.services[0] : null"
                    @change="val => updateRelation('services', val)"></eod-object-autocomplete> -->
                    
                                    <eod-user-selector v-if="!hideUser && $eod.getUser().getRoleGroup() != 'contacts'" class="mb-4" return-object outlined dense clearable label="Eigenaar"
                    :value="value.users ? value.users[0] : null"
                    @change="val => updateRelation('users', val)"></eod-user-selector>
                    
                                    </v-col>
                                </v-row>
                                
                                
                            </v-card-text>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-row>
                            <v-col>
                                <div v-if="value.jobTypes && value.jobTypes[0]">Jobtype: <strong>{{ value.jobTypes[0].name
                        }}</strong></div>
                        <div v-if="value.projects && value.projects[0]">Project: <strong>{{ value.projects[0].name
                        }}</strong></div>
                        <div v-if="value.companies && value.companies[0]">Bedrijf: <strong>{{ value.companies[0].name
                        }}</strong></div>
                            </v-col>
                            <v-col>
                                <div v-if="value.products && value.products[0]">Asset: <strong>{{ value.products[0].name
                        }}</strong></div>
                        <div v-if="value.users && value.users[0]">Eigenaar: <strong>{{
                            (new User(value.users[0])).getFullName()
                        }}</strong></div>
                        <div v-if="value.measurementTypes && value.measurementTypes[0]">Type meetwaarde: <strong>{{
                            value.measurementTypes[0].name
                        }}</strong></div>
                            </v-col>
                        </v-row>
                    </template>
                </div>
                <v-row>
                    <v-col>
                        <eod-autocomplete :value="value.content.type" @change="val => updateContent('type', val)" label="Type" :items="alarmTypes"></eod-autocomplete>
                    </v-col>
                    <v-col>
                        <div class="d-flex">
            <eod-text-field type="number" step="1" label="Interval"
                :value="value.content.interval / value.content.interval_divider" @input="val => updateContent('interval', val)"
                clearable info="Wanneer actief, controleert het systeem de alarmregel continu om de ingestelde intervaltijd">
                <template v-slot:append>
                    <eod-autocomplete class="white" :value="value.content.interval_divider" @change="val => updateContent('interval_divider', val)" :items="[{value:1000, text: 'Seconden'},{value:60000, text: 'Minuten'}]"></eod-autocomplete>
            </template>
            </eod-text-field>
                
            </div>
                    </v-col>
                    <v-col>
                        <div class="d-flex">
            <eod-text-field type="number" step="1" label="Controletijd" clearable
                :value="value.content.toggle_time" @input="val => updateContent('toggle_time', val)"
                info="Systeem verstuurt enkel notificaties wanneer alarm x-aantal minuten de status behoudt">
            <template v-slot:append>
               <div class="px-2">Minuten</div>
            </template>
            </eod-text-field>
            </div>
                    </v-col>
                </v-row>
                
                
                <eod-alarm-detail-thresholds v-if="value.content.type == 'thresholds'" :value="value"
            @input="val => $emit('input', val)"></eod-alarm-detail-thresholds>

        <eod-alarm-detail-listitems v-if="value.content.type == 'listitems'" :value="value"
            @input="val => $emit('input', val)" :valueItems="valueItems"></eod-alarm-detail-listitems>

        <eod-alarm-detail-deadman v-if="value.content.type == 'deadman'" :value="value"
            @input="val => $emit('input', val)"></eod-alarm-detail-deadman>
        <eod-alarm-detail-rateofchange v-if="value.content.type == 'rateofchange'" :value="value"
            @input="val => $emit('input', val)"></eod-alarm-detail-rateofchange>
    </VForm>
</template>
<script>
import eodAlarmDetailThresholds from './eod-alarm-detail-thresholds.vue';
import eodAlarmDetailDeadman from './eod-alarm-detail-deadman.vue';
import eodAlarmDetailRateofchange from './eod-alarm-detail-rateofchange.vue';
import eodAlarmDetailListitems from './eod-alarm-detail-listitems.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodUserSelector from './eod-user-selector.vue';
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import AlarmRule from './../models/alarmRule';
import Product from './../models/product';
import User from './../models/user';
import { VForm } from 'vuetify/lib';

export default {
    name: 'eod-alarm-detail',
    components: {
        eodAlarmDetailThresholds,
        eodAlarmDetailDeadman,
        eodAlarmDetailListitems,
        eodAlarmDetailRateofchange,
        eodObjectAutocomplete,
        eodUserSelector,
        eodObjectsTreeviewInput,
        VForm
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        defaultFilters: {
            type: Object,
            default: () => ({})
        },
        filtersReadonly: {
            type: Boolean,
            default: false
        },
        hideProject: {
            type: Boolean,
            default: false
        },
        hideCompany: {
            type: Boolean,
            default: false
        },
        hideUser: {
            type: Boolean,
            default: false
        },
        hideJobtype: {
            type: Boolean,
            default: false
        },
        hideProduct: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            alarmTypes: AlarmRule.types,
            User: User,
            rules: {
                required: (value, fieldName) => !!value || (fieldName ? fieldName : 'Veld') + ' is verplicht.',
            },
            valueItems: [],
            services: [],
            updateServices: 3434379,
            infoAdvanced: false,
        }
    },
    computed: {
        projectSearch() {
            const company = this.value && this.value.companies && this.value.companies[0];
            if (!company) {
                return [];
            }

            const config = this.$helper.getArrayItemByProperty(Product.searchConfig, 'label', 'Project');

            return [{
                config: { ...config, label: 'Bedrijf', icon: 'mdi-office-building-outline' },
                result: {
                    id: company.id,
                    name: 'Bedrijf',
                    search_title: company.name
                }
            }];
        }
    },
    async created() {
        let val = this.value;
        if (!val) {
            val = {
                name: '',
                type: 'ALARM_RULE',
                object: 'ORGANIZATION',
                access: 'PUBLIC',
                content: {
                    type: "thresholds",
                    interval: 60000,
                    interval_divider: 60000
                },
                measurementTypes: [],
                products: [],
                jobTypes: [],
                companies: [],
                projects: [],
                services: [],
                users: [],
                isActive: true,
            };

            if(!this.filtersReadonly){
                this.infoAdvanced = true;
            }

            this.$emit('input', val);
        } else if(!val.measurementTypes || !val.measurementTypes[0]){
            this.infoAdvanced = true;
        }

        if(!val.content.interval_divider){
            val.content.interval_divider = 1000;
            this.$emit('input', val);
        }

        if (this.defaultFilters && this.defaultFilters.whereInRelated && !val.id) {
            const relationMapping = {
                measurementTypeId: {
                    endpoint: 'measurementType',
                    field: 'measurementTypes',
                    fields: ['id', 'name', 'unit{id name fields{name description} list{fields{name}}}', 'valueConfigList{id name description itemType fields{name description isActive}, listItems{id name description low high threshold stepSize color fields{name description isActive}}}', 'valueConfigListItems{id name description low high threshold stepSize color fields{name description isActive}}']
                },
                productId: {
                    endpoint: 'resolveProduct',
                    field: 'products',
                    fields: ['id','name']
                },
                productTypeId: {
                    endpoint: 'productType',
                    field: 'productTypes',
                    fields: ['id','name']
                },
                jobTypeId: {
                    endpoint: 'jobType',
                    field: 'jobTypes',
                    fields: ['id', 'name', 'defaultProject{id name company{id name}}', 'defaultService{id name}']
                },
                companyId: {
                    endpoint: 'company',
                    field: 'companies',
                    fields: ['id','name','services{id}']
                },
                projectId: {
                    endpoint: 'project',
                    field: 'projects',
                    fields: ['id','name']
                },
                serviceId: {
                    endpoint: 'service',
                    field: 'services',
                    fields: ['id','name']
                },
                userId: {
                    endpoint: 'user',
                    field: 'users',
                    fields: ['id','firstName', 'lastName', 'username']
                },
            }
            for (let i = 0; i < this.defaultFilters.whereInRelated.length; i++) {
                const relationFilter = this.defaultFilters.whereInRelated[i];
                const config = relationMapping[relationFilter.column];
                const item = await this.$eod.getById(config.endpoint, relationFilter.array[0], config.fields)
                    .then(response => {
                        if(response.data.data[config.endpoint]){
                            return response.data.data[config.endpoint];
                        }
                    });

                if(item){
                    val[config.field] = [item];

                    if(relationFilter.column == 'measurementTypeId'){
                        this.updateMeasurement(item);
                    }else{
                        this.updateRelation(config.field, item)
                    }
                }
                
            }
        }
    },
    methods: {
        validate(){
            return this.$refs.form.validate();
        },
        updateContent(property, value) {
            const val = this.value;
            if (val) {
                if(property == 'interval'){
                    this.$set(val.content, 'interval', value * val.content.interval_divider);
                } else {
                    this.$set(val.content, property, value);
                }
                this.$emit('input', val);
            }
        },
        async updateProject(val) {
            this.updateRelation('projects', val ? { id: val } : null);

            if (val) {
                const project = await this.$eod.getById('project', val, ['id', 'name', 'company{id name}'])
                    .then(response => response.data.data.project);

                if (project && project.company) {
                    this.updateRelation('companies', project.company);
                }
            }
        },
        updateCompany(val) {
            this.updateRelation('companies', val ? { id: val } : null);
            // Wanneer het bedrijf wijzigt of gewist wordt, moet het project ook gewist worden
            this.updateRelation('projects', null);
        },
        updateRelation(relationName, object) {
            if(relationName == 'companies'){
                this.services = [];
                if(object && object.services){
                    for (let i = 0; i < object.services.length; i++) {
                        const service = object.services[i];
                        this.services.push(service.id);
                    }
                }
                this.updateServices++;
            }

            const val = this.value;
            // Via $set, want het meegegeven alarm-object heeft de relatiesleutel niet altijd al
            // staan (bv. bij aanmaken vanaf een assettype) en Vue 2 ziet een nieuwe property
            // anders niet - het veld bleef dan leeg (eodportal#1503).
            if (val && object) {
                this.$set(val, relationName, [object]);
            } else if (val){
                this.$set(val, relationName, null);
            }

            this.$emit('input', val);
        },
        updateMeasurement(val) {
            this.updateRelation('measurementTypes', val);

            const items = this.$eod.getMeasurementTypeItems(val);
            this.valueItems = Object.values(items);

            if (this.valueItems && this.valueItems.length > 0) {
                this.updateContent('type', 'listitems');
            }
        }
    }
}
</script>